export default {
  hero_eyebrow: "EL CENTRO DE RECURSOS DE LA HOJA DE CÁLCULO DE USFANS",
  hero_h1: "Hoja de cálculo de USFans — Guías, hallazgos, reseñas y recursos",
  hero_copy:
    "Explora los recursos más recientes de la hoja de cálculo de USFans en un centro organizado. Descubre guías útiles, información de productos, consejos de envío, reseñas y recursos de seguridad, diseñados para que tu investigación sea más rápida y sencilla.",
  hero_cta_primary: "Explorar la hoja de cálculo de USFans",
  hero_cta_secondary: "Ver las últimas guías",
  hero_trust: "Recurso independiente · Actualizado con regularidad · Multilingüe",
  main_btn_1: "hoja de cálculo usfans",
  main_btn_2: "cómpralo ahora",
  dropdown_label: "Explorar categorías",
  dropdown_placeholder: "Selecciona una categoría…",
  categories_title: "Compra por categoría",
  categories_subtitle: "Salta directamente a la categoría que buscas en el sitio principal.",
  text_eyebrow: "SOBRE LA HOJA DE CÁLCULO DE USFANS",
  text_title: "¿Qué es la hoja de cálculo de USFans?",
  text_p1:
    "La hoja de cálculo de USFans es un recurso organizado de estilo comunitario que reúne enlaces de productos, hallazgos y referencias en un solo lugar. En lugar de buscar en publicaciones y mensajes dispersos, la gente la usa como punto de partida para explorar categorías, comparar opciones y seguir pistas hacia los productos que les interesan.",
  text_p2:
    "Un buen recurso en forma de hoja de cálculo ahorra tiempo porque agrupa los artículos en categorías claras — zapatos, sudaderas, camisetas, chaquetas y más — y dirige cada entrada hacia su fuente. Esto hace mucho más fácil pasar de la investigación a explorar realmente la selección completa en el sitio principal.",
  text_p3:
    "Como la hoja de cálculo es un recurso independiente, siempre es prudente verificar los enlaces, revisar los precios actuales y leer los detalles del producto directamente en el sitio de origen antes de tomar cualquier decisión.",
  text_features_title: "Por qué ayuda una hoja de cálculo",
  text_feature_1_title: "Descubrimiento organizado",
  text_feature_1_desc: "Las categorías agrupan los productos para que encuentres lo que necesitas rápidamente.",
  text_feature_2_title: "Investigación más rápida",
  text_feature_2_desc: "Un solo centro reemplaza horas de desplazamiento por información dispersa.",
  text_feature_3_title: "Pasos siguientes claros",
  text_feature_3_desc: "Cada entrada te dirige al sitio de origen para ver los detalles completos.",
  article_entry_title: "Guías destacadas",
  article_entry_subtitle: "Artículos originales y detallados escritos en torno al tema de la hoja de cálculo de USFans.",
  article_1_tag: "Seguridad",
  article_1_title: "¿Es legítimo USFans? Seguridad, reseñas y qué debes saber",
  article_1_desc:
    "Una mirada honesta a cómo verificar la hoja de cálculo de USFans, detectar señales de advertencia y protegerte mientras investigas en línea.",
  article_1_cta: "Leer guía",
  safety_title: "Seguridad y protección de USFans",
  safety_copy:
    "Antes de usar cualquier recurso en línea, verifica la dirección del sitio web, evita descargas sospechosas, protege tus credenciales y verifica de forma independiente la información importante. Este sitio web es un recurso informativo independiente y no garantiza servicios, productos ni transacciones de terceros.",
  safety_cta: "Leer la guía de seguridad de USFans",
  cta_title: "¿Listo para explorar más?",
  cta_copy:
    "Usa nuestras guías y recursos de hoja de cálculo para investigar tus opciones y continúa al sitio principal cuando estés listo para explorar la experiencia completa.",
  cta_primary: "Visitar el sitio principal",
  cta_secondary: "Explorar más guías de USFans",
  faq_title: "Preguntas frecuentes sobre la hoja de cálculo de USFans",
  faq_q1: "¿Qué es una hoja de cálculo de USFans?",
  faq_a1:
    "Es un recurso organizado que reúne enlaces de productos, hallazgos y referencias en un solo centro fácil de explorar, agrupado por categoría.",
  faq_q2: "¿Cómo funciona una hoja de cálculo de USFans?",
  faq_a2:
    "Los artículos se agrupan en categorías y cada entrada dirige a su fuente en el sitio principal, para que puedas pasar de la investigación a la exploración en un clic.",
  faq_q3: "¿Es legítimo USFans?",
  faq_a3:
    "USFansLink es un recurso independiente. Siempre verifica enlaces, precios y detalles del producto directamente en el sitio de origen antes de decidir.",
  faq_q4: "¿Qué debo saber sobre el costo de envío de USFans?",
  faq_a4:
    "El costo de envío depende del sitio de origen, tu ubicación y el método de envío elegido. Consulta la página de pago para obtener la estimación más precisa.",
  faq_q5: "¿USFans ofrece cupones?",
  faq_a5:
    "Las promociones y códigos de descuento, cuando están disponibles, suelen mostrarse en el sitio de origen. Verifica cualquier código antes de usarlo.",
  faq_q6: "¿Dónde puedo encontrar códigos de descuento de USFans?",
  faq_a6:
    "Los códigos de descuento suelen aparecer directamente en el sitio principal o en sus secciones de promociones. Trata los códigos no oficiales con precaución.",
  faq_q7: "¿Qué es el almacén de USFans?",
  faq_a7:
    "El almacén se refiere a la parte de almacenamiento y cumplimiento del sitio de origen. Para obtener detalles precisos, consulta la información de envío y pedidos del sitio de origen.",
  faq_q8: "¿Cómo debo verificar la información de USFans?",
  faq_a8:
    "Verifica los detalles importantes directamente en el sitio de origen oficial y ten cuidado con las afirmaciones no oficiales de terceros.",
};